// extracted by mini-css-extract-plugin
export var layoutContainer = "_7p-0";
export var layoutContainerNoRounding = "_7p-6";
export var layoutContainerOpen = "_7p-5";
export var layoutContainerResizing = "_7p-1";
export var mainContent = "_7p-2";
export var resizeDivider = "_7p-3";
export var slidePanel = "_7p-4";